import {BatchCell} from "@/models/batch/batch.cell";

/**
 *
 * @class CorridorBatch
 *
 * Container for simulation cells in a batch, and where the batch is for one corridor in the CN
 * Rail Network.  Corridor batches get rolled up into a batch of corridors (which is a batch of batches)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class CorridorBatch {

  /** the name of the corridor */
  public name: string      = '';

  /** where we originally imported this corridor from */
  public src: string       = '';

  /** the cells in the batch */
  public cells:
    Map<string, BatchCell> = new Map<string, BatchCell>();

  /** the SWE ID of the batch (i.e. the database object ID) */
  public batchId: number   = -1;

  /** if the batch fails to get imported for this corridor, then this is the import error */
  public error: any        = null;

  /** the UUID of the batch */
  public key: string       = '';

  /** the root folder of the batch for this corridor */
  public prefix: string    = '';

  constructor(name: string, src: string) {

    this.name = name;
    this.src = src;
  }


}

